import { CourseRequirementType, ICourse, ICreateCourseRequirement, PulseCheckSettings } from '@/types/courses';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

export const DEFAULT_NEW_REQUIREMENT: ICreateCourseRequirement = {
  type: CourseRequirementType.watched_minute,
  session_id: 0,
  unit_type: 'discrete',
  points: 0,
  settings: {},
  required_amount: 0,
  // Unused below, will be handled in the API but needed for typescript
  course_id: 0,
  channel: 0,
  created_by: 0,
};

export const defaultSettings = (type: CourseRequirementType): PulseCheckSettings | Record<string, never> => {
  if (type === CourseRequirementType.pulse_check) {
    return {
      pulseCheckDisplayDuration: 5,
      pulseCheckButtonText: {
        base: 'Yes',
        changed: '',
      },
      pulseCheckText: {
        base: 'Are you still watching?',
        changed: '',
      },
      audibleNotification: false,
    } as PulseCheckSettings;
  }
  return {};
};

export const defaultCategories = (course: ICourse | null): TReactSelectOption<string, string, string>[] => {
  if (!course?.categories) return [];

  return course.categories
    .map((c) => {
      return {
        label: `${c}`.trim(),
        value: c,
        meta: c,
      };
    })
    .filter(Boolean) as TReactSelectOption<string, string, string>[];
};
